import React, { useState } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer';
import Newsletter from '../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
    faChevronDown,
} from "@fortawesome/free-solid-svg-icons";

const AccordionItem = ({ title, children }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className={`tc-accordion-item ${open ? 'tc-accordion-open' : ''}`}>
            <button className="tc-accordion-trigger" onClick={() => setOpen(!open)}>
                <span>{title}</span>
                <span className={`tc-accordion-icon ${open ? 'rotated' : ''}`}>
                    <FontAwesomeIcon icon={faChevronDown} />
                </span>
            </button>
            <div className="tc-accordion-body" style={{ maxHeight: open ? '1000px' : '0' }}>
                <div className="tc-accordion-inner">
                    {children}
                </div>
            </div>

            <style>{`
                .tc-accordion-item {
                    border: 1px solid rgba(29, 106, 136, 0.15);
                    border-radius: 10px;
                    margin-bottom: 10px;
                    overflow: hidden;
                    transition: box-shadow 0.3s ease;
                }
                .tc-accordion-item.tc-accordion-open {
                    box-shadow: 0 4px 20px rgba(29, 106, 136, 0.12);
                    border-color: rgba(29, 106, 136, 0.35);
                }
                .tc-accordion-trigger {
                    width: 100%;
                    background: linear-gradient(135deg, rgba(29, 106, 136, 0.05), rgba(0, 168, 204, 0.04));
                    border: none;
                    padding: 14px 20px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    cursor: pointer;
                    font-weight: 600;
                    font-size: 0.95rem;
                    color: #1d6a88;
                    text-align: left;
                    transition: background 0.25s ease;
                }
                .tc-accordion-trigger:hover {
                    background: linear-gradient(135deg, rgba(29, 106, 136, 0.1), rgba(0, 168, 204, 0.08));
                }
                .tc-accordion-open .tc-accordion-trigger {
                    background: linear-gradient(135deg, rgba(29, 106, 136, 0.12), rgba(0, 168, 204, 0.1));
                    color: #002536;
                }
                .tc-accordion-icon {
                    font-size: 0.75rem;
                    color: #00a8cc;
                    transition: transform 0.3s ease;
                    flex-shrink: 0;
                    margin-left: 12px;
                }
                .tc-accordion-icon.rotated {
                    transform: rotate(180deg);
                }
                .tc-accordion-body {
                    max-height: 0;
                    overflow: hidden;
                    transition: max-height 0.4s ease;
                }
                .tc-accordion-inner {
                    padding: 16px 20px 20px;
                    border-top: 1px solid rgba(29, 106, 136, 0.1);
                }
                .tc-accordion-inner p,
                .tc-accordion-inner ul {
                    margin-bottom: 10px;
                }
                .tc-accordion-inner ul {
                    padding-left: 20px;
                }
                .tc-accordion-inner ul li {
                    margin-bottom: 5px;
                    color: #555;
                    line-height: 1.6;
                }
            `}</style>
        </div>
    );
};

export default function PrivacyPolicy() {

    return (
        <>
            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Privacy Policy</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Privacy Policy</li>
                    </ul>
                </div>
            </section>

            <section className="about-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-12">
                            <div className="case-study-content">

                                <p className="case-study-description">
                                    Website: grandindigoembroidery.com<br />
                                    Last Updated: 19/02/2026
                                </p>
                                <p className="case-study-description">
                                    Your privacy is extremely important to us.
                                </p>

                                {/* Section 1 */}
                                <h3 className="case-study-title">1. Information We Collect</h3>
                                <p className="case-study-description">We may collect:</p>

                                <AccordionItem title="1.1 Personal Information">
                                    <ul>
                                        <li>Full Name</li>
                                        <li>Email Address</li>
                                        <li>Phone Number</li>
                                        <li>Billing Information</li>
                                        <li>Shipping Address (for patches)</li>
                                    </ul>
                                </AccordionItem>

                                <AccordionItem title="1.2 Business Information">
                                    <ul>
                                        <li>Company name</li>
                                        <li>Logo files</li>
                                        <li>Branding materials</li>
                                    </ul>
                                </AccordionItem>

                                <AccordionItem title="1.3 Technical Information">
                                    <ul>
                                        <li>IP address</li>
                                        <li>Browser type</li>
                                        <li>Device information</li>
                                        <li>Website usage data</li>
                                    </ul>
                                </AccordionItem>

                                {/* Section 2 */}
                                <h3 className="case-study-title">2. How We Use Your Information</h3>
                                <p className="case-study-description">We use collected data to:</p>
                                <ul>
                                    <li>Process and deliver orders</li>
                                    <li>Communicate order updates</li>
                                    <li>Provide customer support</li>
                                    <li>Improve website performance</li>
                                    <li>Send promotional offers (if subscribed)</li>
                                </ul>
                                <p className="case-study-description">
                                    We do NOT sell, rent, or trade your personal information.
                                </p>

                                {/* Section 3 */}
                                <h3 className="case-study-title">3. Payment Security</h3>
                                <p className="case-study-description">
                                    Payments are processed through secure third-party gateways. We do not store credit card or banking details on our servers.
                                </p>

                                {/* Section 4 */}
                                <h3 className="case-study-title">4. Data Protection & Storage</h3>
                                <ul>
                                    <li>Files and personal data are stored securely.</li>
                                    <li>Access is limited to authorized personnel.</li>
                                    <li>We implement security measures to prevent unauthorized access.</li>
                                </ul>

                                {/* Section 5 */}
                                <h3 className="case-study-title">5. Cookies Policy</h3>
                                <p className="case-study-description">Our website may use cookies to:</p>
                                <ul>
                                    <li>Improve user experience</li>
                                    <li>Analyze traffic</li>
                                    <li>Remember preferences</li>
                                </ul>
                                <p className="case-study-description">
                                    You may disable cookies through your browser settings.
                                </p>

                                {/* Section 6 */}
                                <h3 className="case-study-title">6. Third-Party Services</h3>
                                <p className="case-study-description">We may use trusted third-party services such as:</p>
                                <ul>
                                    <li>Payment processors</li>
                                    <li>Website hosting providers</li>
                                    <li>Email marketing tools</li>
                                    <li>Analytics services</li>
                                </ul>
                                <p className="case-study-description">
                                    These providers operate under their own privacy policies.
                                </p>

                                {/* Section 7 */}
                                <h3 className="case-study-title">7. Data Retention</h3>
                                <p className="case-study-description">
                                    We retain customer files and records for business and support purposes unless deletion is requested.
                                </p>

                                {/* Section 8 */}
                                <h3 className="case-study-title">8. Your Rights</h3>
                                <p className="case-study-description">You have the right to:</p>
                                <ul>
                                    <li>Request access to your personal data</li>
                                    <li>Request correction of inaccurate data</li>
                                    <li>Request deletion of your information</li>
                                    <li>Opt out of marketing communications</li>
                                </ul>
                                <p className="case-study-description">
                                    To exercise these rights, contact us via email.
                                </p>

                                {/* Section 9 */}
                                <h3 className="case-study-title">9. Children's Privacy</h3>
                                <p className="case-study-description">
                                    Our services are not intended for individuals under 18 years of age.
                                </p>

                                {/* Section 10 */}
                                <h3 className="case-study-title">10. Policy Updates</h3>
                                <p className="case-study-description">
                                    We reserve the right to update this Privacy Policy at any time. Changes will be posted on this page with a revised date.
                                </p>

                                {/* Contact Information */}
                                <h3 className="case-study-title">Contact Information</h3>
                                <p className="case-study-description">
                                    Grand Indigo Embroidery<br />
                                    Website: grandindigoembroidery.com<br />
                                    Email: info@grandindigoembroidery.com<br />
                                    Phone: +44 7848 166215
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />
            <Footer />
        </>
    )
}